// importing actions
import {START_FETCH_TEACHER_INFO, SUCCESS_FETCH_TEACHER_INFO, FAILED_FETCH_TEACHER_INFO} from './actions/fetchTeacherInfo'


export default function teacherInfo(state, action){
  switch(action.type){

    // Fetching
    case START_FETCH_TEACHER_INFO: {
      return {...state, ...action.payload}
    }
    case SUCCESS_FETCH_TEACHER_INFO: {
      return {...state, ...action.payload}
    }
    case FAILED_FETCH_TEACHER_INFO: {
      const {error, fetching, hasPermission} = action.payload

      return {...state, error, hasPermission, fetching}
    }


    default: return {...state}
  }
}



// WEBPACK FOOTER //
// ./src/template/Docks/TeacherInfo/redux/reducer.js